import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import {
  ClientReadablePercentage,
  ClientReadableText,
  DevFeatureAction,
  DevTurnOFFAlarm,
  FeatureRolloutPercentageChanger,
  LinkComponent
} from "../../core/et3-table/UserCustomHelpers";
import { isDefinedString, isPositiveNumber, reduce } from "et3-type-guards";
import { DropDownMembersOfDepatment } from "../../core/et3-table/UserCustomHelpers";
import Et3Image from "../../core/et3-Image";
import i18n from "../i18n";
export const DEVELOPER_FLAGGED_CONNECTIONS_DETAILS_HEADERS: GridColDef[] = [
  {
    headerName: "#",
    field: "id"
  },
  {
    headerName: "User ID",
    field: "user_id",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <LinkComponent
          href={`/users/advanced?id=${params.row.user_id}`}
          text={`${params.row.user_id}`}
          style={{}}
        />
      );
    }
  },
  {
    headerName: "Extra Param",
    field: "extra_params",
    flex: 3
  },
  {
    headerName: "Error",
    field: "error"
  },
  {
    headerName: "Route Name",
    field: "route_name"
  },
  {
    headerName: "Created On",
    field: "created_on"
  }
];

export const DEVELOPER_FLAGGED_CONNECTIONS_HISTORY_HEADERS: GridColDef[] = [
  {
    headerName: "#",
    field: "uniqueId"
  },
  {
    headerName: "Date",
    field: "real_date"
  },
  {
    headerName: "Flagged Connections",
    field: "flagged_connections"
  }
];

export const ON_CALL_TEAM_HEADERS: GridColDef[] = [
  {
    headerName: "id",
    field: "id"
  },
  {
    headerName: "Team",
    field: "team"
  },
  {
    headerName: "Name",
    field: "name"
  },
  {
    headerName: "Phone",
    field: "phoneNumber"
  },
  {
    headerName: "Email",
    field: "email"
  },
  {
    headerName: "Select Member",
    field: "selectOnCallMember",
    flex: 2,
    renderCell: (params: GridValueGetterParams) => {
      return <DropDownMembersOfDepatment team={params.row.team} />;
    }
  }
];

export const BLOCKED_REQUESTS_HEADERS: GridColDef[] = [
  {
    headerName: "#",
    field: "id"
  },
  {
    headerName: "UserID",
    field: "userID"
  },
  {
    headerName: "Created On",
    field: "createdOn"
  },
  {
    headerName: "Route Name",
    field: "routeName"
  },
  {
    headerName: "Source",
    field: "source"
  },
  {
    headerName: "DeviceID",
    field: "deviceID"
  },
  {
    headerName: "Ip Address",
    field: "ipAddress"
  },
  {
    headerName: "Extra Paremeters",
    field: "extraParameters",
    flex: 4
  }
];

export const DEVELOPER_ON_CALL_DASHBOARD_USERS_DATA_HEADERS: GridColDef[] = [
  {
    headerName: "ID",
    field: "id",
    sortable: true,
    filterable: true
  },
  {
    headerName: "Date",
    field: "realDate",
    sortable: true,
    filterable: true
  },
  {
    headerName: "New Users",
    field: "newUsers",
    sortable: true,
    filterable: true
  },
  {
    headerName: "Users Increase",
    field: "newUsersIncrease",
    sortable: true,
    filterable: true
  },
  {
    headerName: "Total Users",
    field: "totalUsers",
    sortable: true,
    filterable: true
  },
  {
    headerName: "Flagged Connections",
    field: "flaggedConnections",
    sortable: true,
    filterable: true
  },
  {
    headerName: "Rate Limit",
    field: "rateLimitBlocked",
    sortable: true,
    filterable: true
  }
];

export const DEVELOPER_ON_CALL_PAYMENT_PACKAGES_HEADERS: GridColDef[] = [
  {
    headerName: "Date",
    field: "date"
  },
  {
    headerName: "Bundle Code",
    field: "bundleCode"
  },
  {
    headerName: "Platform",
    field: "platform"
  },
  {
    headerName: "Purchase Count",
    field: "purchaseCount"
  },
  {
    headerName: "Renew Count",
    field: "renewCount"
  },
  {
    headerName: "Bundle Desription",
    field: "bundleDescription"
  }
];

export const DEVELOPER_ON_CALL_PACKAGE_NOTIFICATION_TYPE_COUNT_HEADERS: GridColDef[] =
  [
    {
      headerName: "Date",
      field: "date",
      sortable: true,
      filterable: true
    },
    {
      headerName: "Bundle Notification",
      field: "bundleNotification",
      sortable: true,
      filterable: true
    },
    {
      headerName: "Count",
      field: "bundleNotificationCount",
      sortable: true,
      filterable: true
    }
  ];

export const DEVELOPER_ALARMS_HEADERS: GridColDef[] = [
  {
    headerName: "#",
    field: "id"
  },
  {
    headerName: "Reason ID",
    field: "reason_id"
  },
  {
    headerName: "reason",
    field: "reason"
  },
  {
    headerName: "resolved",
    field: "resolved"
  },
  {
    headerName: "Created On",
    field: "created_on"
  },
  {
    headerName: "Updated On",
    field: "updated_on"
  },
  {
    headerName: "Alarm Action",
    field: "Alarm_Action",
    renderCell: (params: GridValueGetterParams) => {
      const AlarmId = isPositiveNumber(params.row.id) ? params.row.id : 0;
      const reasonID = isPositiveNumber(params.row.reason_id)
        ? params.row.reason_id
        : 0;
      return <DevTurnOFFAlarm AlarmId={AlarmId} reasonID={reasonID} />;
    }
  }
];

export const DEVELOPER_FEATURES_HEADERS: GridColDef[] = [
  {
    headerName: "#",
    field: "uniqueId"
  },
  {
    headerName: "feature id",
    field: "featureId"
  },
  {
    headerName: "Name",
    field: "name"
  },
  {
    headerName: "Gender",
    field: "gender"
  },
  {
    headerName: "Is Active",
    field: "is_active"
  },

  {
    headerName: "Feature rollout percentage",
    field: "feature_rollout_percentage",
    flex: 2,
    renderCell: (params: GridValueGetterParams) => {
      return (
        <FeatureRolloutPercentageChanger featureId={params.row.featureId} />
      );
    }
  },

  {
    headerName: "Action",
    field: "feature_action",
    sortable: false,
    filterable: false,
    flex: 2,
    renderCell: (params: GridValueGetterParams) => {
      const featureID = isPositiveNumber(params.row.featureId)
        ? params.row.featureId
        : -1;
      const featureName = reduce(() => params.row.name, "");
      const isActive = isPositiveNumber(params.row.is_active)
        ? params.row.is_active
        : 0;
      const gender = isDefinedString(params.row.gender)
        ? params.row.gender
        : "";
      return (
        <DevFeatureAction
          featureID={featureID}
          featureName={featureName}
          isActive={isActive}
          gender={gender}
        />
      );
    }
  }
];



export const DEVELOPER_BLOCKED_REQUESTS_HISTORY_HEADERS: GridColDef[] = [
  {
    headerName: "Date",
    field: "real_date"
  },
  {
    headerName: "Rate Limit",
    field: "rate_limit_blocked"
  }
];

export const DEVELOPER_BLOCKED_REQUESTS_DETAILS_HEADERS: GridColDef[] = [
  {
    headerName: "#",
    field: "id"
  },
  {
    headerName: "UserID",
    field: "userID"
  },
  {
    headerName: "Date",
    field: "createdOn"
  },
  {
    headerName: "Route Name",
    field: "routeName"
  },
  {
    headerName: "Source",
    field: "source"
  },
  {
    headerName: "DeviceID",
    field: "deviceID"
  },
  {
    headerName: "Display Device ID",
    field: "displayDeviceID",
    flex: 1.5
  },
  {
    headerName: "Ip Address",
    field: "ipAddress"
  },
  {
    headerName: "Extra Paremeters",
    field: "extraParameters",
    flex: 4
  }
];

export const DEVELOPER_STATS_DASHBOARD_PAYMENT_PACKAGES_HEADERS: GridColDef[] = [
  {
    headerName: "Date",
    field: "date"
  },
  {
    headerName: "Bundle Code",
    field: "bundleCode"
  },
  {
    headerName: "Platform",
    field: "platform"
  },
  {
    headerName: "Period",
    field: "period"
  },
  {
    headerName: "Purchase Count",
    field: "purchaseCount"
  },
  {
    headerName: "Renew Count",
    field: "renewCount"
  },
  {
    headerName: "Bundle Description",
    field: "bundleDescription"
  }
];

export const DEVELOPER_STATS_DASHBOARD_PACKAGE_NOTIFICATION_TYPE_COUNT_HEADERS: GridColDef[] =
  [
    {
      headerName: "Date",
      field: "date"
    },
    {
      headerName: "Bundle Notification",
      field: "bundleNotification"
    },
    {
      headerName: "Count",
      field: "bundleNotificationCount"
    }
  ];

export const DEVELOPER_STATS_DASHBOARD_USERS_DATA_HEADERS: GridColDef[] = [
  {
    headerName: "ID",
    field: "id"
  },
  {
    headerName: "Date",
    field: "realDate"
  },
  {
    headerName: "New Users",
    field: "newUsers"
  },
  {
    headerName: "Users Increase",
    field: "newUsersIncrease"
  },
  {
    headerName: "Total Users",
    field: "totalUsers"
  },
  {
    headerName: "Flagged Connections",
    field: "flaggedConnections"
  },
  {
    headerName: "Rate Limit",
    field: "rateLimitBlocked"
  }
];

export const DEVELOPER_STATS_DASHBOARD_SUBSCRIPTIONS_AND_PURCHASES_HEADERS: GridColDef[] =
  [
    {
      headerName: "ID",
      field: "id"
    },
    {
      headerName: "Subscriptions",
      field: "newSubscription"
    },
    {
      headerName: "Subscriptions Increase",
      field: "newSubscriptionIncrease"
    },
    {
      headerName: "Android Subscription",
      field: "androidSubscription"
    },
    {
      headerName: "IOS Subscription",
      field: "iosSubscription"
    },
    {
      headerName: "Web Subscription",
      field: "webSubscription"
    },
    {
      headerName: "Renewals",
      field: "newRenewals"
    },
    {
      headerName: "Android Renewals",
      field: "androidRenewals"
    },
    {
      headerName: "IOS Renewals",
      field: "iosRenewals"
    },
    {
      headerName: "Web Renewals",
      field: "webRenewals"
    }
  ];

export const DEVELOPER_STATS_DASHBOARD_ON_CALL_HEADERS: GridColDef[] = [
  {
    headerName: "Date",
    field: "real_date"
  },
  {
    headerName: "New Users",
    field: "new_users"
  },
  {
    headerName: "Users Increase",
    field: "new_users_increase",
    renderCell: (params: GridValueGetterParams) => {
      return <ClientReadablePercentage value={params.row.new_users_increase} />;
    }
  },
  {
    headerName: "Total Users",
    field: "total_users"
  },
  {
    headerName: "Subscriptions",
    field: "new_subscription"
  },
  {
    headerName: "Subscriptions Increase",
    field: "new_subscription_increase"
  },
  {
    headerName: "Android Subscription",
    field: "android_subscription"
  },
  {
    headerName: "IOS Subscription",
    field: "ios_subscription"
  },
  {
    headerName: "Web Subscription",
    field: "web_subscription"
  },
  {
    headerName: "Renewals",
    field: "new_renewals"
  },
  {
    headerName: "Android Renewals",
    field: "android_renewals"
  },
  {
    headerName: "IOS Renewals",
    field: "ios_renewals"
  },
  {
    headerName: "Web Renewals",
    field: "web_renewals"
  },
  {
    headerName: "Email Campaign",
    field: "email_campaign_count"
  }
];

export const DEVELOPER_AI_IMAGE_CHECK_HEADERS: GridColDef[] = [
  {
    headerName: "ID",
    field: "id"
  },
  {
    headerName: "Status",
    field: "status"
  },
  {
    headerName: "Reason",
    field: "reason"
  },
  {
    headerName: "Platform",
    field: "platform"
  },
  {
    headerName: "Label Caught",
    field: "label_caught"
  },
  {
    headerName: "Confidence Caught",
    field: "confidence_caught"
  },
  {
    headerName: "Picture URL",
    field: "picture_url",
    renderCell: (params: GridValueGetterParams) => {
      console.warn(params);

      return (
        <Et3Image
          type={"ONLINE"}
          alt={i18n.get("ALKHATTABA_ADMIN")}
          imageName={`${params.row.picture_url}`}
          size={140}
          onClick={() => {}}
          style={{}}
        />
      );
    }
  }
];

export const DEVELOPER_AI_IMAGE_COMPARE_HEADERS: GridColDef[] = [
  {
    headerName: "ID",
    field: "id"
  },
  {
    headerName: "user_id",
    field: "user_id"
  },
  {
    headerName: "matchResult",
    field: "matchResult"
  },
  {
    headerName: "similarity",
    field: "similarity"
  },
  {
    headerName: "selfiePicURL",
    field: "selfiePicURL",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <Et3Image
          type={"ONLINE"}
          alt={i18n.get("ALKHATTABA_ADMIN")}
          imageName={`${params.row.selfiePicURL}`}
          size={140}
          onClick={() => {}}
          style={{}}
        />
      );
    }
  },
  {
    headerName: "pictureToBeComparedURL",
    field: "pictureToBeComparedURL",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <Et3Image
          type={"ONLINE"}
          alt={i18n.get("ALKHATTABA_ADMIN")}
          imageName={`${params.row.pictureToBeComparedURL}`}
          size={140}
          onClick={() => {}}
          style={{}}
        />
      );
    }
  }
];

export const DEVELOPER_SUB_TABS_ACCESS_SUMMARY_HEADERS: GridColDef[] = [
  {
    headerName: "Sub-Tab Name",
    field: "subTab",
    flex: 2
  },
  {
    headerName: "Access Count",
    field: "accessCount"
  },
  {
    headerName: "Last Accessed Date",
    field: "lastAccess"
  },
  {
    headerName: "Accessed By",
    field: "accessedBy"
  }
];

export const DEVELOPER_GENERATED_TABLES_SUMMARY_HEADERS: GridColDef[] = [
  {
    headerName: "Sub-Tab Name",
    field: "subTab",
    flex: 2.5
  },
  {
    headerName: "Table Name",
    field: "subTabTable",
    renderCell: (params: GridValueGetterParams) => {
      return <ClientReadableText text={params.row.subTabTable} />;
    },
    flex: 2.5
  },
  {
    headerName: "Generation Count",
    field: "generationCount"
  },
  {
    headerName: "Last Generation Date",
    field: "lastGenerated"
  },
  {
    headerName: "Generated By",
    field: "generatedBy"
  }
];
